import { ERROR, SUCCESS } from "../constants/types/alertType";
import {
  CLEAR_SUBSCRIPTION_PROMO_DETAIL,
  SUBSCRIPTION_LIST_RECEIVED,
  SUBSCRIPTION_PROMO_CODE_APPLIED,
  USER_ACTIVE_SUBSCRIPTION_INFO_RECEIVED,
} from "../constants/types/subscriptionType";
import axios from "../utils/axios";
import { getUserDetail, setUserSubscription } from "../utils/helper";
import { appLoading } from "./alertAction";
export const getSubscriptionList = (callback) => (dispatch) => {
  axios
    .get(
      `subscription?action=getUserSubscriptionList&roleId=${
        getUserDetail()?.mainRole.val
      }`
    )
    .then(
      (resp) => {
        if (resp.data.success) {
          dispatch({
            type: SUBSCRIPTION_LIST_RECEIVED,
            payload: resp.data.subscriptions,
          });
          callback && callback();
        } else {
          dispatch({
            type: SUBSCRIPTION_LIST_RECEIVED,
            payload: [],
          });
          dispatch({
            type: ERROR,
            payload: resp.data.error,
          });
          callback && callback();
        }
      },
      (err) => {
        console.log(err);
        dispatch({
          type: ERROR,
          payload: "Failed to get subscription List",
        });
        callback && callback();
      }
    );
};

export const clearSubscriptionPromoDetail = () => (dispatch) => {
  dispatch({
    type: CLEAR_SUBSCRIPTION_PROMO_DETAIL,
    payload: null,
  });
};

export const applySubscriptionPromoCode = (code) => (dispatch) => {
  axios.get(`subscription?action=checkPromoCode&promo_code=${code}`).then(
    (resp) => {
      if (resp.data?.result === "success") {
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
        dispatch({
          type: SUBSCRIPTION_PROMO_CODE_APPLIED,
          payload: resp.data,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getSubscriptionListById = (id, callback) => (dispatch) => {
  axios.get(`subscription?action=getUserSubscriptionList&roleId=${id}`).then(
    (resp) => {
      if (resp.data.success) {
        dispatch({
          type: SUBSCRIPTION_LIST_RECEIVED,
          payload: resp.data.subscriptions,
        });
        callback && callback();
      } else {
        dispatch({
          type: SUBSCRIPTION_LIST_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
        callback && callback();
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to get subscription List",
      });
      callback && callback();
    }
  );
};

export const subscriptionPostAction = (data, callback) => (dispatch) => {
  dispatch(appLoading(true));
  axios.post("subscription", data).then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
        if (data.params.action == "removeUserSubscription") {
          setUserSubscription(0);
        } else {
          setUserSubscription(1);
        }
        callback && callback();
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
        callback && callback();
      }
      dispatch(appLoading(false));
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
      dispatch(appLoading(false));
    }
  );
};

export const getUserActiveSubscription = (callback) => (dispatch) => {
  axios.get("subscription?action=getUserActiveSubscription").then(
    (resp) => {
      if (resp.data.result == "success") {
        dispatch({
          type: USER_ACTIVE_SUBSCRIPTION_INFO_RECEIVED,
          payload: resp.data.subscriptionInfo,
        });
        callback && callback();
      } else {
        dispatch({
          type: USER_ACTIVE_SUBSCRIPTION_INFO_RECEIVED,
          payload: null,
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
        callback && callback();
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to get subscription List",
      });
      callback && callback();
    }
  );
};
